import React from "react";
import styled from "styled-components";
import { down, only, up } from "styled-breakpoints";
import getGridHeight from "@src/utils/getGridHeight";
import settings from "@src/settings";
import { Container as ContainerBase } from "../styles";
import IntroImg from "./IntroImg";
import getGridWidth from "@src/utils/getGridWidth";

export const Container = styled(ContainerBase)`
	display: flex;
	align-items: flex-start;
	padding: 0 0 ${getGridHeight({ rows: 1, withTopGap: true })}px;
	& > ${IntroImg} {
		flex: 1 1 auto;
		margin-top: ${getGridHeight({ rows: 5, withBottomGap: true })}px;
		z-index: 1;
		${up("xl")} {
			margin-left: -6rem;
			height: ${getGridHeight({ rows: 20 })}px;
		}
		${only("lg")} {
			margin-left: -12rem;
			height: ${getGridHeight({ rows: 16 })}px;
		}
		${only("md")} {
			flex: 0 0;
			flex-basis: calc(
				(23rem + (100% - ${settings.contentWidth.md}px) / 2) * (4 / 3)
			);
			margin-top: ${getGridHeight({ rows: 7, withBottomGap: true })}px;
			margin-left: -11rem;
			height: ${getGridHeight({ rows: 16 })}px;
		}
		${only("sm")} {
			width: calc(
				(100% - ${settings.contentWidth.sm}px) / 2 +
					${settings.contentWidth.sm}px * (4 / 3)
			);
			margin-left: calc((100% - ${settings.contentWidth.sm}px) / 2);
			margin-top: ${getGridHeight({ rows: 2, withTopGap: true }) * -1}px;
			height: ${getGridHeight({ rows: 16 })}px;
		}
		${down("xs")} {
			width: ${(props) => `calc(
				(100% - ${
					getGridWidth({ windowW: props.windowW }) -
					settings.baseGrid.fontSize * 4
				}px) / 2 +
					${
						getGridWidth({ windowW: props.windowW }) -
						settings.baseGrid.fontSize * 4
					}px * (4 / 3)
			)`};
			margin-left: calc(
				(
						100% -
							${(props) =>
								getGridWidth({ windowW: props.windowW }) -
								settings.baseGrid.fontSize * 4}px
					) / 2
			);
			margin-top: ${getGridHeight({ rows: 2, withTopGap: true }) * -1}px;
			height: ${getGridHeight({ rows: 12 })}px;
		}
	}
	${down("md")} {
		width: 100%;
	}
	${down("sm")} {
		flex-direction: column;
	}
`;
export const Box = styled.div`
	flex: 0 0 30rem;
	width: 30rem;
	padding: 0 5rem ${getGridHeight({ rows: 4 })}px;
	margin-left: -5rem;
	border-radius: 0 0 35px 0;
	background-color: #fff;
	position: relative;
	z-index: 2;
	${only("lg")} {
		padding: ${getGridHeight({ rows: 1 })}px 4rem
			${getGridHeight({ rows: 3 })}px;
		margin-left: -4rem;
	}
	${only("md")} {
		flex-basis: 27rem;
		width: 27rem;
		padding: ${getGridHeight({ rows: 1 })}px 4rem
			${getGridHeight({ rows: 3 })}px;
		margin-left: calc((100% - ${settings.contentWidth.md}px) / 2 - 4rem);
	}
	${down("sm")} {
		flex-basis: auto;
		width: 100%;
		margin-left: 0;
		padding: 0 0
			${getGridHeight({ rows: 2, withBottomGap: true, withTopGap: true })}px;
	}
`;
export const Text = styled.div<{ windowW: number | null }>`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	${down("sm")} {
		margin: 0 auto;
	}
	${only("sm")} {
		width: ${settings.contentWidth.sm}px;
	}
	${down("xs")} {
		width: ${(props) =>
			getGridWidth({ windowW: props.windowW }) -
			settings.baseGrid.fontSize * 4}px;
	}
`;
